export default __webpack_public_path__ + "static/media/desk_preland_9.c9d33a3d.jpg";